// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"eb79f16e","469":"b7499e8d"}[chunkId] + ".chunk.css";
};